export const CODE_SPLIT_FAILED_TO_LOAD = 'CODE_SPLIT_FAILED_TO_LOAD';
export const DISCONNECTED_FROM_PUBSUB = 'DISCONNECTED_FROM_PUBSUB';
export const SUBSCRIPTIONS_FAILED = 'SUBSCRIPTIONS_FAILED';